import { render, staticRenderFns } from "./DoctorDocumentUploadFields.vue?vue&type=template&id=21d6dc6a&scoped=true"
import script from "./DoctorDocumentUploadFields.vue?vue&type=script&lang=js"
export * from "./DoctorDocumentUploadFields.vue?vue&type=script&lang=js"
import style0 from "./DoctorDocumentUploadFields.vue?vue&type=style&index=0&id=21d6dc6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6dc6a",
  null
  
)

export default component.exports